import { LoadingBlock } from "../components/LoadingBlock";
import { cn } from "../lib/utils";
import React from "react";
/**
 * An avatar beside custom placeholder content. The 28px avatar and 8px gap match
 * DataTable.CellContent. Use rounded for user avatars and leave it false for
 * agent avatars. Supply the text lines explicitly to match the column's content.
 */
export function AvatarCellSkeleton({
  children,
  rounded = false,
  className,
  avatarClassName
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: cn("flex min-w-0 items-center gap-2", className)
  }, /*#__PURE__*/React.createElement(LoadingBlock, {
    className: cn("h-7 w-7 shrink-0", rounded ? "rounded-full" : "rounded-md", avatarClassName)
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 flex-col gap-1"
  }, children));
}
//# sourceMappingURL=AvatarCellSkeleton.js.map